<template>
    <div name="proof" class="proof">
        <span class="p-title">고객 추천도 94%<span class="footnote">1)</span></span>
        <span class="p-title">솔닥 재진율 80%<span class="footnote">2)</span></span>
        <span class="p-title">누적 이용자 수 50만+<span class="footnote">2)</span></span>
        <span class="p-sub-title">쉽고 간편한 솔닥, 고객만족도가 증명합니다</span>
        <img class="mockup-5" src="../../assets/renew_mobile/proof.png" alt="1) 2023년 3월 기준, 솔닥 고객 만족도 조사 그래프"/>
        <span class="p-footer-title">1) 2023년 3월 기준, 솔닥 고객 만족도 조사<br/>2) 2023년 3월 31일 기준</span>
    </div>
</template>

<script>
export default {
    name:'proof',
    mounted: function()
    {
        // let eheight = $('.introduction').outerHeight();

        $(window).scroll(function () {
            var height = $(document).scrollTop();
            // let winHeight = $(window).height();
            if(height > 1880 && height < 3300)
            {
                $('.p-title').css('display', `inline-block`);
                $('.p-sub-title').css('display', `inline-block`);
                $('.mockup-5').css('display', `inline-block`);
                $('.p-footer-title').css('display', `inline-block`);
            }
            else if(height >= 3300)
            {                
                $('.p-title').css('display', `inline-block`);
                $('.p-sub-title').css('display', `inline-block`);
                $('.mockup-5').css('display', `inline-block`);
                $('.p-footer-title').css('display', `inline-block`);
			
            }            
        })
    }
}
</script>

<style scoped>
    @media screen and (max-width: 360px){
        .proof{
            width: 100%;
            height: 484px;
            background: #fff;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            padding-top: 63px;
            position: relative;
        }

        .p-title{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 600;
            font-size: 23px;
            line-height: 30px;
            text-align: center;
            color: #1A1A1A;
            position: relative;
            display: none;
            animation: fadeInUp 1s;
        }
        .footnote{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 300;
            font-size: 13px;
            line-height: 44px;
            text-align: center;
            color: #CCCCCC;
            position: absolute;
            top: -7px;
            right: -14px;            
        }
        .p-sub-title{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            text-align: center;
            color: #666666;
            margin-top: 12px;
            display: none;
            animation: fadeInUp1 1s;
        }

        .mockup-5 {
            position: absolute;    
            top: 200px;
            /* left: 50%; */
            width: 129px;
            animation: fadeInUp 1s;
            z-index: 1;
            display: none;
        }

        .p-footer-title {
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 10px;
            line-height: 16px;
            text-align: center;
            color: #666666;
            position: absolute;   
            top: 396px;
            display: none;
            animation: fadeInUp3 1s;
        }
    }
    @media screen and (min-width: 361px){
        .proof{
            position: relative;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-direction: column;
            width: 100%;
            height: 740px;
            padding-top: 112px;
            background: #fff;
        }

        .p-title{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 600;
            font-size: 32px;
            line-height: 44px;
            text-align: center;
            color: #1A1A1A;
            position: relative;
            display: none;
            animation: fadeInUp 1s;
        }
        .footnote{
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 300;
            font-size: 15px;
            line-height: 44px;
            text-align: center;
            color: #CCCCCC;
            position: absolute;
            top: -1px;
            right: -14px;
            
        }

        .p-sub-title{
            display: none;
            margin-top: 18px;
            font-weight: 400;
			font-size: 16px;
            line-height: 30px;
            text-align: center;
            color: #666;
            animation: fadeInUp1 1s;
        }

        .mockup-5 {
            position: absolute;    
            top: 323px;
            /* left: 50%; */
            animation: fadeInUp 1s;
            z-index: 1;
            display: none;
        }

        .p-footer-title {
            font-family: 'Pretendard';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            text-align: center;
            color: #666;
            position: absolute;   
            top: 609px;
            display: none;
            animation: fadeInUp3 1s;
        }
    }

    
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 50%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 150%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes fadeInUp2 {
        0% {
            opacity: 0;
            transform: translate3d(0, 150%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes fadeInUp3 {
        0% {
            opacity: 0;
            transform: translate3d(0, 150%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_main/Proof.vue